import React from 'react';
import { connect } from 'react-redux';
import { PageNormalMainLayoutStyled } from './styled';
import { Route, Switch } from 'react-router-dom';
import pageNormalRoutes from 'routes/pageNormalRoutes';
// import { NavbarWeb, FooterPage } from 'components';

class PageNormalMainLayout extends React.Component {
  state = {};

  render() {
    return (
      <PageNormalMainLayoutStyled>
        <div className="content_mainlayout">
          <Switch>
            {pageNormalRoutes &&
              pageNormalRoutes.map((e, i) => {
                return !e.sub ? (
                  <Route
                    key={i}
                    exact={e.exact}
                    path={e.path}
                    component={e.component}
                  />
                ) : (
                  e.subComponent.map((e2, i2) => (
                    <Route
                      key={i2}
                      exact={e2.exact}
                      path={e2.path}
                      component={e2.component}
                    />
                  ))
                );
              })}
          </Switch>
        </div>
        {/* <FooterPage theme_standard /> */}
      </PageNormalMainLayoutStyled>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageNormalMainLayout);
